import React, { useEffect, useState } from "react";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "../firebase";

export default function LoginComplete() {
  const [msg, setMsg] = useState("Finishing sign-in…");

  useEffect(() => {
    const finish = async () => {
      const href = window.location.href;

      if (!isSignInWithEmailLink(auth, href)) {
        setMsg("Not a valid sign-in link.");
        return;
      }

      let email = window.localStorage.getItem("emailForSignIn");
      if (!email) email = window.prompt("Confirm your email:");

      try {
        await signInWithEmailLink(auth, email, href);
        window.localStorage.removeItem("emailForSignIn");
        window.location.href = "/modules";
      } catch (err) {
        console.error(err);
        setMsg(err?.message || "Sign-in failed.");
      }
    };

    finish();
  }, []);

  return <div style={{ padding: 24 }}>{msg}</div>;
}
